// Back to top: shows once the page has scrolled past the threshold, as on the old site.
const button = document.querySelector('[data-scroll-top]');
const threshold = 300;
const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

function toggle() {
    button.classList.toggle('is-visible', window.scrollY > threshold);
}

if (button) {
    window.addEventListener('scroll', toggle, {passive: true});
    toggle();

    button.addEventListener('click', () => {
        window.scrollTo({top: 0, behavior: reducedMotionQuery.matches ? 'auto' : 'smooth'});
        // Keyboard users carry on from the top of the page instead of the hidden button.
        document.getElementById('main')?.focus({preventScroll: true});
    });
}
